/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BookingRevocationEligibilityDto = {
    bookingId: string;
    revocable: boolean;
    /**
     * Last moment the statutory revocation (Widerruf) is allowed.
     */
    revocableUntil: string | null;
    revocationPolicyId: string | null;
    revocationDays: number | null;
    revocationBlockedAt: string | null;
    revocationBlockedReason: BookingRevocationEligibilityDto.revocationBlockedReason | null;
    /**
     * When true and revocable, a refund must be executed on revoke.
     */
    refundRequired: boolean;
    /**
     * True when revoke only ends the booking (e.g. FREE order) without a payment refund.
     */
    revocationNotNecessary: boolean;
};
export namespace BookingRevocationEligibilityDto {
    export enum revocationBlockedReason {
        WAIVER = 'WAIVER',
        MULTIPASS_USED = 'MULTIPASS_USED',
    }
}

